import type { UntitledIconData } from '@faceup/icons'
import { ulUpload03 } from '@faceup/icons/ulUpload03'
import type { ReactNode } from 'react'

export type UpsellData = {
  name: string
  title: ReactNode
  description: ReactNode
  features: ReactNode[]
  icon: UntitledIconData
  image?: ReactNode
  showUpsell: boolean
}

export const upsellDisabled: UpsellData = {
  title: '',
  description: '',
  features: [],
  icon: ulUpload03,
  showUpsell: false,
  name: '',
}
